module.exports = __webpack_public_path__ + "media/go_to_your_room.a54512cb.mp4";